import React, { useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box } from '@mui/material';
import { PostAddTwoTone } from "@mui/icons-material";
import DrawerViewEdit from "../../../../ui-component/components/DrawerViewEdit";
import { useIntl } from "react-intl";
import ActivityForm from "../../../../ui-component/shared/ActivityForm";

// ==============================|| ACTIVITY HEADER BUTTON ||============================== //

const ActivitySection = () => {

    const theme = useTheme();
    const anchorRef = useRef<any>(null);
    const intl = useIntl()

    // drawer state
    const [openDrawer, setOpenDrawer] = useState<boolean>(false);
    const handleDrawerChangeState = () => {
        setOpenDrawer((prevState) => !prevState);
    };

    const handleToggle = () => {

    };

    return (
        <>
            <Box
                sx={{
                    ml: 2,
                    mr: 4,
                    [theme.breakpoints.down('md')]: {
                        ml: 1
                    }
                }}
            >
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        border: '1px solid',
                        borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.dark,
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.dark,
                        color: theme.palette.secondary.light,
                        transition: 'all .2s ease-in-out',
                        '&[aria-controls="menu-list-grow"],&:hover': {
                            borderColor: theme.palette.primary.main,
                            background: theme.palette.primary.main,
                            color: theme.palette.primary.light
                        }
                    }}
                    ref={anchorRef}
                    aria-haspopup="true"
                    onClick={handleDrawerChangeState}
                    color="inherit"
                >
                    <PostAddTwoTone sx={{ fontSize: '1.2rem' }} />
                </Avatar>
            </Box>
            <DrawerViewEdit
                open={openDrawer}
                title={intl.formatMessage({ id: 'CAA00002' })}
                caption={intl.formatMessage({ id: 'CAA00004' })}
                handleDrawerChangeState={handleDrawerChangeState}
                handleDrawerDeleteRecord={handleToggle}
                isDeleteEnabled={false}
                children={<ActivityForm handleDrawerChangeState={handleDrawerChangeState} />} />
        </>
    );
};

export default ActivitySection;